import 'bootstrap/dist/css/bootstrap.css'
import 'assets/scss/paper-dashboard.scss'
import 'assets/scss/fmps.scss'
import AuthState from 'context/auth/AuthState'
import ProductState from 'context/product/ProductState'
import { createBrowserHistory } from 'history'
import AuthLayout from 'layouts/Auth'
import Submission from 'layouts/Submission'
import React from 'react'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import ReactDOM from 'react-dom'
import { Redirect, Route, Router, Switch } from 'react-router-dom'
import SubmitState from 'context/submit/SubmitState'
import PageState from 'context/page/PageState'
import Maintenance from 'components/Maintenance/Maintenance'

// import { makeServer } from './server'

// if (process.env.NODE_ENV === 'development') {
/*makeServer()*/
// }

import { SecureRoute, Security, LoginCallback } from '@okta/okta-react'
import { OktaAuth, toRelativeUrl } from '@okta/okta-auth-js'

const oktaAuth = new OktaAuth({
  issuer: window.config.issuer,
  clientId: window.config.clientId,
  redirectUri: window.location.origin + '/login/callback',
  scopes: ['openid', 'profile', 'email', 'aplss_api'],
})

const hist = createBrowserHistory()
const restoreOriginalUri = async (_oktaAuth, originalUri) => {
  hist.replace(toRelativeUrl(originalUri || '/', window.location.origin))
}

// console.log = function() {}

ReactDOM.render(
  <Security oktaAuth={oktaAuth} restoreOriginalUri={restoreOriginalUri}>
    <AuthState>
      <SubmitState>
        <ProductState>
          {/* <AlertState> */}
          <PageState>
            <Router history={hist}>
              <Switch>
                {/* <Route component={Maintenance} /> */}
                <Route path="/login/callback" component={LoginCallback} />
                <Route path="/auth/login" component={AuthLayout} />
                <Route path="/auth/register" component={AuthLayout} />
                <Route path="/auth/forgotpassword" component={AuthLayout} />
                <SecureRoute path="/auth">
                  <AuthLayout />
                </SecureRoute>
                <SecureRoute path="/submission">
                  <Submission />
                </SecureRoute>
                <Redirect from="/" to="/auth/login" />
              </Switch>
            </Router>
          </PageState>
          {/* </AlertState> */}
        </ProductState>
      </SubmitState>
    </AuthState>
  </Security>,
  document.getElementById('root')
)
